import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SweetAlertService from "../../../services/SweetAlertService";
import { errorMessages, getMaxLengthErrorMessage, getRequiredErrorMessage, jobCategoryNameMaxLength, jobCategoryActivityNamePattern } from "../Shared/Constants/AdminModuleConstants";
import JobCategoryService from "../Shared/Services/JobCategoryService";

export const CreateJobCategory = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, reset, formState: { errors } } = useForm(
        { defaultValues: { name: "", shortName: "", isCountToSession: "false", isDefaultInWorkActivity: "false" } }
    );

    const formSubmit = (data: any) => {
        data.name = data.name.trim();
        data.shortName = data.shortName.trim();
        data.isCountToSession = data.isCountToSession == 'true';
        data.isDefaultInWorkActivity = data.isDefaultInWorkActivity == 'true';
        JobCategoryService.addJobCategory(data).then((response) => {
            if (response.data > 0) {
                navigate("/jobcategory");
            } else {
                SweetAlertService.error("Error", "Something went wrong while adding job category");
            }
            reset();
        }).catch(error => {
            SweetAlertService.error("Error", error.response.data.errors.Name[0]);
        })
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Create Job Category</h4>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit(formSubmit)}>
                    <div className="form-group row">
                        <label className="col-lg-3 control-label">Name</label>
                        <div className="col-lg-9">
                            <input
                                type="text"
                                className="form-control"
                                {...register("name", {
                                    required: getRequiredErrorMessage("Name"),
                                    maxLength: {
                                        value: jobCategoryNameMaxLength,
                                        message: getMaxLengthErrorMessage(jobCategoryNameMaxLength)
                                    },
                                    pattern: {
                                        value: jobCategoryActivityNamePattern,
                                        message: errorMessages.pattern
                                    },
                                })}
                            />
                            {errors.name && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.name.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <label className="col-lg-3 control-label">Short Name</label>
                        <div className="col-lg-9">
                            <input
                                type="text"
                                className="form-control"
                                {...register("shortName", {
                                    required: getRequiredErrorMessage("Short Name"),
                                    maxLength: {
                                        value: jobCategoryNameMaxLength,
                                        message: getMaxLengthErrorMessage(jobCategoryNameMaxLength)
                                    },
                                    pattern: {
                                        value: jobCategoryActivityNamePattern,
                                        message: errorMessages.pattern
                                    }
                                })}
                            />
                            {errors.shortName && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.shortName.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <label className="col-lg-3 control-label">Count To Sessions</label>
                        <div className="col-lg-9">
                            <div className="d-flex flex-row">
                                <input
                                    value="true"
                                    type="radio"
                                    {...register("isCountToSession")}
                                />
                                Yes
                                <input className="ms-3"
                                    value="false"
                                    type="radio"
                                    {...register("isCountToSession")}
                                />No
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <label className="col-lg-3 control-label">Is Default In WorkActivity</label>
                        <div className="col-lg-9">
                            <div className="d-flex flex-row">
                                <input
                                    value="true"
                                    type="radio"
                                    {...register("isDefaultInWorkActivity")} />
                                Yes
                                <input className="ms-3"
                                    value="false"
                                    type="radio"
                                    {...register("isDefaultInWorkActivity")}
                                />No
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <div className=" col-sm-offset-3 px-2">
                            <a className="btn btn-secondary" onClick={() => navigate('/jobcategory')}>
                                Cancel
                            </a>
                            <button className="btn btn-primary ms-1" type="submit">
                                Create
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default CreateJobCategory;